import { Provider } from 'react-redux';

import TopicsAppContainer from '../containers/TopicsAppContainer';
import createStore from '../store/topicsStore';

const store = createStore();

export default (props) => (
  <Provider store={store}>
    <TopicsAppContainer {...props} />
  </Provider>
);
